export default __webpack_public_path__ + "static/media/20forbeer.96be59d5.txt";